var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"ellipsis-loader"},_vm._l(([].concat( Array(3) )),function(dot,index){return _c('div',{key:index,staticClass:"mx-20",style:({
            animationDelay: ((index * 0.33) + "s")
        })})}),0)}
var staticRenderFns = []

export { render, staticRenderFns }